export default __webpack_public_path__ + "static/media/wechat.622cb7d4.jpg";